import {isOutlookPanel} from '../outlook/dialog';

/**
 * Dowas the injection supports minipanel OR should all invalid content show full-panel content (e.g. no-screen)
 * (For now only outlook, but e.g. when G-suit will be supported...)
 * @return {Boolean} True for alled minipanel
 */
export function allowedMiniPanel() {
	if (isOutlookPanel()) {
		return false;
	}

	return true;
}
